export enum DOCUMENT_STATUS {
  AVAILABLE = 'Available',
  FAILED = 'Failed',
  NOT_AVAILABLE = 'Not Available',
  PENDING = 'Pending',
  IN_REVIEW = 'In Review',
}
